import { BUTTON, CLOSE_BUTTON, CONTAINER, FULLSCREEN, IMAGE, STANDARD } from '../constants.js';

export const is = {
	widget: {
		containerType: isProperty('type', CONTAINER),
		buttonType: isProperty('type', BUTTON),
		closeRole: isProperty('role', CLOSE_BUTTON),
		imageType: isProperty('type', IMAGE),
	},
	slideDisplayMode: {
		fullscreen(slide){
			return slide._displayMode === FULLSCREEN;
		},
		standard(slide){
			return slide._displayMode === STANDARD;
		}
	}
};

function isProperty(property, value){
	return (widget) => {
		try {
			const actual = typeof widget[property] === 'string' ?
				widget[property] :
				widget[`_${property}`];
			return actual === value;
		} catch (exception){
			console.error(exception);
		}
	};
}
